<div class="delete-report-category-dialog">
    <h2 mat-dialog-title class="dialog-title">
        <i class="ri-alert-line text-danger me-2"></i>
        Confirmar Eliminación
    </h2>
    <mat-dialog-content class="dialog-content">
        <p class="warning-message">
            ¿Está seguro de que desea quitar el reporte
            <strong>{{ data.mapping.reportName }}</strong> de la categoría
            <strong>{{ data.mapping.category }}</strong
            >?
        </p>
        <div class="alert-warning">
            <i class="ri-information-line me-2"></i>
            <span
                >El reporte dejará de mostrarse en el módulo KPI
                correspondiente. Puede volver a asignarlo en cualquier
                momento.</span
            >
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="onCancel()" class="cancel-button">
            <i class="ri-close-line me-2"></i>
            Cancelar
        </button>
        <button
            mat-raised-button
            color="warn"
            (click)="onConfirm()"
            class="confirm-button"
        >
            <i class="ri-delete-bin-line me-2"></i>
            Eliminar
        </button>
    </mat-dialog-actions>
</div>
